import { render, staticRenderFns } from "./deleteAccount.vue?vue&type=template&id=21c66b1a&"
import script from "./deleteAccount.vue?vue&type=script&lang=ts&"
export * from "./deleteAccount.vue?vue&type=script&lang=ts&"
import style0 from "./deleteAccount.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports